import type { ReactElement } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { DashboardLayout } from './components/layout';
import { RELEASE_LOCKS } from './lib/release-flags';
import { HomePage } from './pages/home';
import { FeatureComingSoonPage } from './pages/platform-coming-soon';
import { ProjectsPage } from './pages/projects';
import { BuilderPage } from './pages/builder';
import {
  PonzinomicsOverviewPage,
  MemeGeneratorPage,
  QuestsPage,
  LeaderboardsPage,
} from './pages/ponzinomics';
import { SettingsPage } from './pages/settings';
import { BillingPage } from './pages/billing';
import { IntegrationsOverviewPage } from './pages/integrations';
import {
  PresaleDiscoverPage,
  PresaleDetailPage,
  PresaleCreatePage,
  PresaleManagePage,
  WhitelistPage,
  MyPresalesPage,
} from './pages/presale';
import { TokenDeployPage } from './pages/token/deploy';

export function App(): ReactElement {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<DashboardLayout />}>
          {/* Home */}
          <Route index element={<HomePage />} />

          {/* Projects */}
          <Route path="projects" element={<ProjectsPage />} />

          {/* Ponzinomics */}
          <Route path="ponzinomics">
            <Route index element={<PonzinomicsOverviewPage />} />
            <Route path="meme" element={<MemeGeneratorPage />} />
            <Route path="quests" element={<QuestsPage />} />
            <Route path="leaderboards" element={<LeaderboardsPage />} />
          </Route>

          {/* Builder */}
          <Route
            path="builder"
            element={
              RELEASE_LOCKS.builder ? <FeatureComingSoonPage feature="builder" /> : <BuilderPage />
            }
          />

          {/* Settings */}
          <Route
            path="settings"
            element={
              RELEASE_LOCKS.settings ? (
                <FeatureComingSoonPage feature="settings" />
              ) : (
                <SettingsPage />
              )
            }
          />

          {/* Token Deploy */}
          <Route path="token/deploy" element={<TokenDeployPage />} />

          {/* Billing */}
          <Route
            path="billing"
            element={
              RELEASE_LOCKS.billing ? <FeatureComingSoonPage feature="billing" /> : <BillingPage />
            }
          />

          {/* Presale */}
          <Route path="presale">
            <Route index element={<PresaleDiscoverPage />} />
            <Route path="create" element={<PresaleCreatePage />} />
            <Route path="whitelist" element={<WhitelistPage />} />
            <Route path="my-presales" element={<MyPresalesPage />} />
            <Route path=":id/manage" element={<PresaleManagePage />} />
            <Route path=":id" element={<PresaleDetailPage />} />
          </Route>

          {/* Integrations */}
          <Route path="integrations">
            <Route index element={<IntegrationsOverviewPage />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
